import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileArchive,
  faFileImage,
  faFileCode,
  faFile
} from '@fortawesome/free-solid-svg-icons';
import {getLocalTimezoneLabel} from '../../../../../utils/datetime';

/**
 * Format date and time for display, in the viewer's local timezone (labelled)
 */
export const formatDateTime = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '-';
  const pad = (n) => String(n).padStart(2, '0');
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mins = pad(d.getMinutes());
  return `${yyyy}-${mm}-${dd} ${hh}:${mins} ${getLocalTimezoneLabel(d)}`;
};

/**
 * Get file icon and color based on extension
 */
export const getFileIcon = (ext) => {
  const e = (ext || '').toLowerCase();
  if (['pdf'].includes(e)) return {icon: faFilePdf, color: 'text-red-600 dark:text-red-400'};
  if (['doc', 'docx'].includes(e)) return {icon: faFileWord, color: 'text-blue-600 dark:text-blue-400'};
  if (['xls', 'xlsx', 'csv'].includes(e)) return {icon: faFileExcel, color: 'text-green-600 dark:text-green-400'};
  if (['zip', 'rar', '7z', 'tar', 'gz'].includes(e)) return {
    icon: faFileArchive,
    color: 'text-amber-600 dark:text-amber-400'
  };
  if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(e)) return {
    icon: faFileImage,
    color: 'text-brand-600 dark:text-brand-400'
  };
  if (['txt', 'json', 'xml', 'js', 'py', 'html', 'css'].includes(e)) return {
    icon: faFileCode,
    color: 'text-slate-600 dark:text-slate-400'
  };
  return {icon: faFile, color: 'text-gray-600 dark:text-gray-400'};
};

/**
 * Normalize a file object to a consistent structure
 */
export const normalizeFile = (raw) => {
  const fileUrl = raw.file_url || raw.file || raw.url || raw.download_url;
  const name = raw.description || raw.name || (typeof fileUrl === 'string' ? fileUrl.split('/').pop() : raw.filename) || 'unnamed';
  const parts = String(name).split('.');
  const ext = parts.length > 1 ? parts.pop().toLowerCase() : '';

  return {
    id: raw.id || raw.pk || `${name}-${raw.created_at || raw.created || ''}`,
    name,
    ext,
    size: raw.size || raw.filesize || raw.byte_size || raw.human_size || '',
    uploaded: raw.uploaded_at || raw.created_at || raw.created || '',
    resourceId: raw.resource || raw.resource_id || null,
    raw,
  };
};

/**
 * Normalize exports list to a consistent array structure
 */
export const normalizeExportsList = (exportedFiles) => {
  const e = exportedFiles || [];
  if (Array.isArray(e)) return e;
  if (e && typeof e === 'object') {
    if (Array.isArray(e.results)) return e.results;
    if (Array.isArray(e.data)) return e.data;
    return [e];
  }
  return [];
};

